import { MovieClip } from '@play-co/timestep-core/ui';
import { Container, Sprite } from '../../../odie';
import { PopcornBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/popcorn'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class PopcornBlockView extends Container {
  private movieclip: MovieClip;

  constructor(props: PopcornBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    this.movieclip.play('popcorn_state02', null, true);
  }

  public static assets() {
    return Object.values(manifest());
  }

  public async playTransition() {
    await this.movieclip.playAsync('popcorn_tranisition_1_2');
    this.movieclip.play('popcorn_state02', null, true);
  }
}
